import { React, useState, useEffect } from "react";
import { Modal, Popover, Button } from "antd";

import { ActionButton } from "../../../elements/Button";

import "./styles.scss";
import colors from "../../../../styles/_colors.scss";
import { CloseOutlined } from "@ant-design/icons";

const defaultPopoverMessage = () => (
  <div>Please fill in all required fields to proceed</div>
);

export const SideMenu = (props) => {
  const {
    globalState,
    setGlobalState,
    modalContent,
    saveFunction,
    modalWidth = "narrow",
    saveStatus,
    confirmationNeeded = false,
    popoverMessage = defaultPopoverMessage,
    showSaveButton = true,
    disableSaveButton = true,
    customModalClass = "",
    discardFunction = () => {},
  } = props;

  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setOpen(false);
    saveFunction();
  };
  const handleCancel = () => {
    setOpen(false);
    // Don't close main modal - just close confirmation popup and continue editing
  };

  const handleDiscard = () => {
    discardFunction(); // reset data in parent
    setOpen(false); // close this confirmation modal
    setGlobalState(false); // close the main modal window and discard edits
    // Force re-render of modal content to reset any form state
    setCurModalContent(<></>);
    setTimeout(() => setCurModalContent(modalContent), 0);
  };

  const [curModalContent, setCurModalContent] = useState(<></>);
  useEffect(() => setCurModalContent(modalContent), [modalContent]);

  const slideLeftClass = "slide-left";
  const slideRightClass = "slide-right";
  const fadeInClass = "m-fadeIn";
  const fadeOutClass = "m-fadeOut";

  const [modalState, setModalState] = useState(false);
  const [modalWidthClass, setModalWidthClass] = useState("");
  const [modalStateClasses, setModalStateClasses] = useState(
    [slideRightClass, fadeOutClass].join(" ")
  );
  const [bkgStateClasses, setBkgStateClasses] = useState(fadeOutClass);

  useEffect(() => {
    setModalState(globalState);
    let widthClass = modalWidth === "wide" ? "modal-wide" : "";
    if (customModalClass) {
      widthClass = customModalClass;
    }
    setModalWidthClass(widthClass);

    switch (globalState) {
      case true:
        setModalStateClasses([slideLeftClass, fadeInClass].join(" "));
        setBkgStateClasses(fadeInClass);
        break;
      case false:
        setModalStateClasses([slideRightClass, fadeOutClass].join(" "));
        setBkgStateClasses(fadeOutClass);
        break;
    }
  }, [globalState, modalWidth, customModalClass]);

  const handleModalClose = () => {
    switch (saveStatus) {
      case 1:
      case true:
        showModal();
        break;
      default:
        setModalState(false);
        setGlobalState(false);
    }
  };

  // hide the scrollbar on the main page when the modal window is open
  useEffect(() => {
    switch (modalState) {
      case true:
        document.body.classList.add("no-scroll");
        break;
      default:
        document.body.classList.remove("no-scroll");
    }

    return () => document.body.classList.remove("no-scroll");
  }, [modalState]);

  return (
    <div className="modal-area">
      <div className={`modal-window ${modalWidthClass} ${modalStateClasses}`}>
        <div className="modal-content-cc">
          <div className="modal-elems">{curModalContent}</div>
        </div>
        <div className="modal-buttons-area">
          <div className="modal-buttons">
            <Popover
              content={null}
              trigger="hover"
            >
              <>
                {showSaveButton && (
                  <ActionButton
                    size="large"
                    type="save"
                    disabled={disableSaveButton} // TODO: Popover is now always disabled. Needs to be enabled in the future based on form validation.
                    width={140}
                    onClickFunction={() => saveFunction()}
                  >
                    Save
                  </ActionButton>
                )}
              </>
            </Popover>
          </div>
        </div>
      </div>
      <div
        className={`bkg-shad ${bkgStateClasses}`}
        onClick={handleModalClose}
      ></div>
      <Modal
        open={open}
        centered
        title={
          <div className="closeIconDiv">
            <span>Save your changes</span>
            <CloseOutlined onClick={handleCancel} className="closeIcon" />
          </div>
        }
        onCancel={handleCancel}
        closable={false}
        footer={[
          <Button key="discard" type="default" onClick={handleDiscard}>
            discard
          </Button>,
          <Button key="save" type="saveChanges" onClick={handleOk}>
            save changes
          </Button>,
          // <Button
          //   key="cancel"
          //   style={{ borderRadius: "14px" }}
          //   onClick={handleCancel}
          // >
          //   Cancel
          // </Button>,
        ]}
      >
        <p>Do you want to save changes before leaving this step?</p>
      </Modal>
    </div>
  );
};
